import { Link } from "react-router-dom";
import { blogPosts } from "../../../mocks/blogPosts";

interface PostSidebarProps {
  currentId: number;
}

export default function PostSidebar({ currentId }: PostSidebarProps) {
  return (
    <aside className="w-72 flex-shrink-0">
      <div className="sticky top-28">
        {/* Header */}
        <div className="flex items-center justify-between mb-5 pb-4 border-b border-black/10">
          <p
            className="text-black/30 text-[10px] tracking-[0.35em] uppercase"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            All Stories
          </p>
          <Link
            to="/blog"
            className="text-[10px] tracking-[0.15em] uppercase text-black/40 hover:text-black transition-colors flex items-center gap-1"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            View all
            <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center" />
          </Link>
        </div>

        {/* Post List */}
        <div className="space-y-1">
          {blogPosts.map((post) => {
            const isActive = post.id === currentId;
            return (
              <Link
                key={post.id}
                to={`/blog/${post.id}`}
                className={`group flex gap-3 p-3 rounded-sm transition-all duration-200 ${
                  isActive
                    ? "bg-black"
                    : "hover:bg-black/5"
                }`}
              >
                {/* Thumbnail */}
                <div className="w-14 h-14 flex-shrink-0 overflow-hidden rounded-sm bg-[#e8e8e8]">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                {/* Text */}
                <div className="flex-1 min-w-0">
                  <span
                    className={`text-[9px] tracking-[0.2em] uppercase font-bold block mb-1 ${
                      isActive ? "text-white/50" : "text-black/30"
                    }`}
                    style={{ fontFamily: "'Barlow', sans-serif" }}
                  >
                    {post.category}
                  </span>
                  <p
                    className={`text-[12px] font-bold leading-tight line-clamp-2 mb-1 transition-opacity ${
                      isActive
                        ? "text-white"
                        : "text-black group-hover:opacity-70"
                    }`}
                    style={{ fontFamily: "'Barlow', sans-serif" }}
                  >
                    {post.title}
                  </p>
                  <span
                    className={`text-[10px] ${isActive ? "text-white/40" : "text-black/30"}`}
                    style={{ fontFamily: "'Barlow', sans-serif" }}
                  >
                    {post.readTime}
                  </span>
                </div>

                {/* Active indicator */}
                {isActive && (
                  <div className="flex items-center flex-shrink-0">
                    <i className="ri-book-open-line text-white/60 text-xs w-4 h-4 flex items-center justify-center" />
                  </div>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </aside>
  );
}
